"use strict";

const AuthEorrorCode = [
  {
    code: 0,
    message: "성공"
  },
  {
    code: 10000,
    message: "등록되지 않은 cliendt_id입니다"
  },
  {
    code: 10001,
    message: "잘못된 redirect_url입니다"
  },
  {
    code: 10002,
    message: "아이디 또는 비밀번호가 일치하지 않거나 가입 이력이 없습니다. \n※ 5회 이상 오류 시 본인 확인 필요"
  },
  {
    code: 10003,
    message: "로그인 불가상태입니다"
  },
  {
    code: 10004,
    message: "인증코드를 발급 할 수 없습니다"
  },
  {
    code: 10005,
    message: "탈퇴대기 계정입니다"
  },
  {
    code: 10006,
    message: "휴면계정 입니다"
  },
  {
    code: 10007,
    message: "로그인 제재 계정입니다"
  },
  {
    code: 10008,
    message: "전환하지 않은 로컬 서비스 계정입니다"
  },
  {
    code: 10009,
    message: "서비스 이용약관 동의하지 않은 계정입니다"
  },
  {
    code: 10010,
    message: "인증토큰을 인증 할 수 없습니다"
  },
  {
    code: 10011,
    message: "refresh token 인증 실패입니다"
  },
  {
    code: 10012,
    message: "accesstoken 인증 실패입니다"
  },
  {
    code: 10013,
    message: "client ip확인 실패 입니다"
  },
  {
    code: 10014, //패스워드 5회 오류 캡챠
    message: "아이디 또는 비밀번호가 일치하지 않거나 가입 이력이 없습니다. \n※ 5회 이상 오류 시 본인 확인 필요"
  },
  {
    code: 10018, //비번오류
    message: "아이디 또는 비밀번호가 일치하지 않거나 가입 이력이 없습니다. \n※ 5회 이상 오류 시 본인 확인 필요"
  },
  {
    code: 10019,
    message: "전환 유저 정보가 없음"
  },
  {
    code: 10020,
    message: "전환 로컬계정의 정보와 통합계정정보가 다름"
  },
  {
    code: 10021,
    message: "서비스 ID 를 찾을 수 없음"
  },
  {
    code: 10022,
    message: "서비스 시크릿키가 틀림"
  },
  {
    code: 10023,
    message: "APPLE ID TOKEN 으로 프로필 조회시 토큰이 맞지 않음"
  },
  {
    code: 10024,
    message: "구글 캡차 인증 중 오류가 발생했습니다"
  },
  {
    code: 10025,
    message: "PASSWORD 변경이 일정기간 이상 경과 됨. 패스워드 변경으로 전환"
  },
  {
    code: 10056,
    message: "이용 해지된 계정입니다.\n(탈퇴 후 {date}일 간 이용이 제한됩니다.)"
  },
  {
    code: 10057,
    message: "이용 해지된 계정입니다.\n(탈퇴 후 {date}일 간 이용이 제한됩니다.)"
  },
  {
    // 서비스 토큰 bearer 누락
    code: 10081,
    message: "인증시스템 오류입니다."
  },
  {
    // 서비스 토큰 인증 실패
    code: 10086,
    message: "인증시스템 오류입니다."
  },
  {
    // 서비스 토큰 누락
    code: 10087,
    message: "인증시스템 오류입니다."
  },
  {
    code: 19999,
    message: "인증시스템 오류입니다"
  },
  {
    code: 99999,
    message: "인증 중 오류가 발생하였습니다"
  }
];

export default AuthEorrorCode;
